export default __webpack_public_path__ + "static/media/icon-new-google-play.2bcca134.png";